// Components
const ClientHeader = () => import(/* webpackPrefetch: true, webpackChunkName: "client-header" */ '@/app/views/client-view/_shared/client-header/client-header.vue');
const TheFooter = () => import(/* webpackPrefetch: true, webpackChunkName: "the-footer" */ '@/app/views/main-view/_shared/the-footer/the-footer.vue');
const PuppyForSalePage = () => import(/* webpackPrefetch: true, webpackChunkName: "puppy-for-sale-page" */ '@/app/views/client-view/puppy-for-sale-page/components/puppy-for-sale-page/puppy-for-sale-page.vue');

// Mixins
import { googleTagManagerMixins } from '@/app/mixins/utils/google-tag-manager-mixins';

export default {
    name: 'PuppyForSaleContainer',
    mixins: [ googleTagManagerMixins ],
    components: {
        ClientHeader,
        TheFooter,
        PuppyForSalePage,

    },
    computed: {
        isNativeApp() {
            return this.$store.getters.getIsNativeApp;
        },
    },
    data() {
        return {
            hasLatitudePay: false,
            showMainLogo: true
        };
    },
}